// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"527":"d1c08138","588":"d1c08138","613":"9ac7ae49","626":"9ac7ae49"}[chunkId] + ".chunk.css";
};